import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";


function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>

            <div className="d-row j-equal gap-9">
                <UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="pensionDeduction" upload={upload} inExtWindow={inExtWindow}/>
                <UploadDataPoint setMortgage={setMortgage} name="grossBasic" upload={upload} inExtWindow={inExtWindow}/>
            </div>
            {/*<div className="d-row j-equal gap-9">*/}
            {/*    /!*<UploadDataPoint setMortgage={setMortgage} name="grossPay" upload={upload} inExtWindow={inExtWindow}/>*!/*/}
            {/*    /!*<UploadDataPoint setMortgage={setMortgage} name="netPay" upload={upload} inExtWindow={inExtWindow}/>*!/*/}
            {/*</div>*/}
            {/*<Typography.Title level={5}>*/}
            {/*    If applicable, enter up-to-date average yearly amounts for the following deductions*/}
            {/*</Typography.Title>*/}
            {/*<div className="d-row j-equal gap-9">*/}
            {/*    <UploadDataPoint setMortgage={setMortgage} name="pensionDeduction" upload={upload} inExtWindow={inExtWindow}/>*/}
            {/*    <UploadDataPoint setMortgage={setMortgage} name="avcDeduction" upload={upload} inExtWindow={inExtWindow}/>*/}
            {/*</div>*/}
            {/*<div className="d-row j-equal gap-9">*/}
            {/*    <UploadDataPoint setMortgage={setMortgage} name="shareSave" upload={upload} inExtWindow={inExtWindow}/>*/}
            {/*    <UploadDataPoint setMortgage={setMortgage} name="bik" upload={upload} inExtWindow={inExtWindow}/>*/}
            {/*</div>*/}
        </>
    );


}


export default DataForm;